// RU-SUITEOPS SO-7: the Go-Live flow shared by Strategy Builder and the Strategy Suites review. GoLiveModal is
// unchanged; this is the gate check Strategy Builder applies before opening it, its initial state and the request its
// submit sends after the typed confirmation. Nothing here runs without the modal's own submit.

// Same check as Strategy Builder's openLiveModal: a set min_paper_trades must have its gate passed.
export function goLiveGateBlock(s) {
  const gate = s?.live_gate || {};
  const gateOk = !gate.min_paper_trades || gate.gate_passed;
  if (gateOk) return null;
  const has = gate.current_count ?? s?.qualification?.paper?.trades ?? 0;
  return `Live gate not met: needs ${gate.min_paper_trades} paper trades, has ${has}. Paper trade first or lower the gate.`;
}

export const goLiveInitialState = (s) =>
  ({ strategy: s, broker: "zerodha", qty: 1, daily: 3, notional: 25000, typed: "", autopilot: false });

export const CONFIRM_TEXT = "DEPLOY LIVE";

// The modal's submit: refuses unless the typed confirmation matches (the modal also disables its button).
export async function submitGoLive(api, state) {
  if (!state || state.typed !== CONFIRM_TEXT) throw new Error("Type 'DEPLOY LIVE' exactly to confirm");
  return api.post(`/strategies/${state.strategy.id}/deploy`, {
    mode: "live", enabled: true, broker: state.broker,
    max_qty_per_order: Number(state.qty),
    max_orders_per_day: Number(state.daily),
    notional_cap_per_order: Number(state.notional),
    typed_confirm: CONFIRM_TEXT,
    autopilot: state.autopilot ?? false,
  });
}
